<template src="./reopenAllotmentModal.pug" lang="pug"></template>

<script>
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'ReopenAllotmentModal',

  components: {
    ConfirmModal,
    ButtonPrimary
  },

  data () {
    return {
      disableButton: false
    }
  },

  computed: {
    allotmentId () {
      return this.$store.getters.idAllotment
    }
  },

  methods: {
    confirmReopenAllotment () {
      let data = {
        idLote: this.allotmentId
      }
      this.$store.dispatch('loadingData').then(() => {
        this.disableButton = true
        this.$store.dispatch('reopenConciliation', data)
          .then((response) => {
            this.confirmReopenSuccess(response)
          })
          .catch((error) => {
            this.confirmReopenError(error)
          })
      })
    },

    // Acao tomada no sucesso da Reabertura
    confirmReopenSuccess (response) {
      this.disableButton = false
      this.$store.dispatch('cleanEditState')
      this.closeModal()
      this.$root.$refs.notification.global('S', this.$t(response.data.message))
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true)
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true)
      this.$store.dispatch('dataLoaded')
    },

    // Acao tomada no erro da Reabertura
    confirmReopenError (error = {}) {
      this.disableButton = false
      this.closeModal()
      this.$root.$refs.notification.global('E', error && error.data && error.data.message
        ? this.$t(error.data.message)
          : error && error.message
          ? this.$t(error.message)
        : this.$t('GENERAL'))
      this.$store.dispatch('dataLoaded')
    },

    closeModal () {
      $('#reopenAllotmentModal').modal('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReopenAllotmentModal.vue?1a573a61